import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { DocAnalyzeResponse, DocConfirmResponse } from '@/types/adminDocumentSubmit'

export const documentAnalyze = createAsyncThunk<
  DocAnalyzeResponse,
  { userId: string; group: string; files: File[] }
>(
  API_ROUTES.ADMIN_DOCUMENT_ANALYZE,
  async ({ userId, group, files }) => {
    const formData = new FormData()
    formData.append('user_id', userId)
    formData.append('group', group)
    files.forEach((file) => formData.append('files', file))
    const res = await apiClient.post<DocAnalyzeResponse>(
      API_ROUTES.ADMIN_DOCUMENT_ANALYZE,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return res
  }
)

export const documentConfirm = createAsyncThunk<
  DocConfirmResponse,
  { body: DocAnalyzeResponse }
>(
  'adminDocumentSubmit/confirm',
  async ({ body }) => {
    const res = await apiClient.post<DocConfirmResponse>(
      API_ROUTES.ADMIN_DOCUMENT_CONFIRM,
      body
    )
    return res
  }
)

interface AdminDocumentSubmitState {
  analyzeResult: DocAnalyzeResponse | null
  analyzeLoading: boolean
  confirmLoading: boolean
  error: string | null
}

const initialState: AdminDocumentSubmitState = {
  analyzeResult: null,
  analyzeLoading: false,
  confirmLoading: false,
  error: null,
}

const adminDocumentSubmitSlice = createSlice({
  name: 'adminDocumentSubmit',
  initialState,
  reducers: {
    clearAnalyzeResult: (state) => {
      state.analyzeResult = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(documentAnalyze.pending, (state) => {
        state.analyzeLoading = true
        state.error = null
      })
      .addCase(documentAnalyze.fulfilled, (state, action) => {
        state.analyzeResult = action.payload
        state.analyzeLoading = false
      })
      .addCase(documentAnalyze.rejected, (state, action) => {
        state.error = action.error.message || 'エラーが発生しました'
        state.analyzeLoading = false
      })
      .addCase(documentConfirm.pending, (state) => {
        state.confirmLoading = true
        state.error = null
      })
      .addCase(documentConfirm.fulfilled, (state) => {
        state.confirmLoading = false
        state.analyzeResult = null
      })
      .addCase(documentConfirm.rejected, (state, action) => {
        state.error = action.error.message || 'エラーが発生しました'
        state.confirmLoading = false
      })
  },
})

export const { clearAnalyzeResult } = adminDocumentSubmitSlice.actions
export default adminDocumentSubmitSlice.reducer
